export default __webpack_public_path__ + "static/media/manifestationofregrowth.31b8f73b.png";